import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('findDatasets');
const type = createActionType('findDatasets');

export const SELECT_TABLE = type('SelectTable');
export const SELECT_TAB = type('SelectTab');

export const GET_SNOWFLAKE_TABLE_COLUMNS = apiType('GetSnowflakeTableColumns');
export const GET_COLUMN_METADATA = apiType('GetColumnMetadata');
